<template>
  <button v-bind="$attrs" :class="classObj">
    <slot name="default"></slot>
  </button>
</template>

<script lang="ts" setup>
defineOptions({ inheritAttrs: false });

const props = defineProps({
  variant: {
    type: String as PropType<"default" | "small">,
    default: "default",
  },
});

const classObj = computed(() => {
  return {
    "btn-primary": true,
    "btn-primary--small": props.variant === "small",
  };
});
</script>

<style lang="postcss">
.btn-primary {
  @apply bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded;

  &--small {
    @apply py-1 px-2 text-sm;
  }
}
</style>
